import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentFullPipe, MomentNoAddYearPipe, MomentPipe, MomentPipeAgo, MomentThMonth, MomentThPipe, MomentThPipestartOf, MomentThYear, MomentTimePipe } from './moment/moment.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { MomentAgoPipe } from './moment-ago/moment-ago.pipe';
import { MomentjsPipe } from './momentjs/momentjs.pipe';
import { CustomTranslatePipe, translateLanguagePipe } from './translate/translate.pipe';
import { EmojiTypeImagePipe, EmojiTypeNamePipe } from './emojiTypeImage/emoji-type-image.pipe';
import { FormatCountPipe } from './format-count/format-count.pipe';

@NgModule({
    declarations: [
        FormatCountPipe,
        MomentNoAddYearPipe, 
        SafeHtmlPipe, 
        MomentAgoPipe, 
        MomentjsPipe, 
        CustomTranslatePipe,
        translateLanguagePipe,
        EmojiTypeImagePipe,
        EmojiTypeNamePipe,
        MomentFullPipe, 
        MomentNoAddYearPipe, 
        MomentPipe, 
        MomentPipeAgo, 
        MomentThMonth, 
        MomentThPipe, 
        MomentThPipestartOf, 
        MomentThYear, 
        MomentTimePipe
    ],
    imports: [CommonModule],
    exports: [
        MomentFullPipe, 
        MomentNoAddYearPipe, 
        MomentPipe, 
        MomentPipeAgo, 
        MomentThMonth, 
        MomentThPipe, 
        MomentThPipestartOf, 
        MomentThYear, 
        MomentTimePipe,
        SafeHtmlPipe, 
        FormatCountPipe,
        MomentAgoPipe, 
        MomentjsPipe,
        CustomTranslatePipe,
        translateLanguagePipe,
        EmojiTypeImagePipe,
        EmojiTypeNamePipe
    ],
    providers: []
})

export class PipeModule { }
